module.exports = __webpack_public_path__ + "img/buy.60041807.png";